import { h } from 'preact'
import style from './styles/summary.scss'

const title = s => s[0]
const value = s => s[1]

const Summary = ({summary}) => (
  <ul class={style.normal}>
    {summary.map((s, i) => (
      <li key={i} class={style.key}>{title(s)}: <strong class={style.value}>{value(s)}</strong></li>
    ))}
  </ul>
)

export default Summary



// WEBPACK FOOTER //
// ./components/ChatBot/Summary.js